"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (pips) {
    return Math.abs(Math.log10(pips));
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/number/pipsToDigits.js
// module id = 106
// module chunks = 0